(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ag-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.ag-ba__frame').forEach(function (frame) {
        var range = frame.querySelector('.ag-ba__range');
        if (!range) return;
        range.addEventListener('input', function () {
          frame.style.setProperty('--pos', range.value + '%');
        }, { passive: true });
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-pdp-video"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function init() {
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        document.querySelectorAll('.ag-pv').forEach(function (sec) {
          var v = sec.querySelector('.ag-pv__vid');
          if (!v) return;
          function load() { if (!v.getAttribute('src') && v.dataset.src) { v.setAttribute('src', v.dataset.src); } }
          v.addEventListener('click', function () { load(); if (v.paused) { v.play().catch(function () {}); } else { v.pause(); } });
          var btn = sec.querySelector('.ag-pv__sound');
          if (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              load();
              v.muted = !v.muted;
              sec.classList.toggle('is-unmuted', !v.muted);
              if (!v.muted) { v.play().catch(function () {}); }
            });
          }
          if (reduce || !('IntersectionObserver' in window)) return;
          new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) { load(); v.play().catch(function () {}); } else { v.pause(); }
            });
          }, { threshold: 0.5 }).observe(v);
        });
      }
      if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var sections = document.querySelectorAll('.ag-rl');
      sections.forEach(function (sec) {
        var track = sec.querySelector('.ag-rl__track');
        if (!track) return;
        var auto = sec.getAttribute('data-autoscroll') === 'true' && !reduce;

        // Seamless infinite loop: duplicate the cards once so the row can scroll continuously.
        var count = 0;
        if (auto) {
          var originals = Array.prototype.slice.call(track.children);
          count = originals.length;
          originals.forEach(function (c) { track.appendChild(c.cloneNode(true)); });
        }

        function load(v) { if (!v.getAttribute('src') && v.dataset.src) { v.setAttribute('src', v.dataset.src); } }

        track.querySelectorAll('.ag-rl__vid').forEach(function (v) {
          v.addEventListener('click', function () {
            load(v);
            if (v.paused) { v.play().catch(function () {}); } else { v.pause(); }
          });
        });

        track.querySelectorAll('.ag-rl__sound').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var card = btn.closest('.ag-rl__card');
            var v = card.querySelector('.ag-rl__vid');
            load(v);
            v.muted = !v.muted;
            card.classList.toggle('is-unmuted', !v.muted);
            if (!v.muted) { v.play().catch(function () {}); }
          });
        });

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              var v = en.target;
              if (en.isIntersecting) { load(v); v.play().catch(function () {}); }
              else { v.pause(); }
            });
          }, { threshold: 0.5 });
          track.querySelectorAll('.ag-rl__vid').forEach(function (v) { io.observe(v); });
        }

        if (!auto) return;
        var kids = track.children;
        var paused = false, visible = true;
        ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
          track.addEventListener(ev, function () { paused = true; }, { passive: true });
        });
        ['pointerleave', 'touchend', 'focusout'].forEach(function (ev) {
          track.addEventListener(ev, function () { paused = false; }, { passive: true });
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.02 }).observe(sec);
        }
        (function tick() {
          if (!paused && visible) {
            track.scrollLeft += 0.7;
            var lw = kids[count] ? (kids[count].offsetLeft - kids[0].offsetLeft) : 0;
            if (lw > 0 && track.scrollLeft >= lw) { track.scrollLeft -= lw; }
          }
          requestAnimationFrame(tick);
        })();
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ag-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('.ag-rv').forEach(function (sec) {
        if (sec.getAttribute('data-autoscroll') !== 'true' || reduce) return;
        var track = sec.querySelector('.ag-rv__track');
        if (!track) return;
        var originals = Array.prototype.slice.call(track.children);
        var count = originals.length;
        if (count < 2) return;
        originals.forEach(function (c) { var cl = c.cloneNode(true); cl.setAttribute('aria-hidden', 'true'); track.appendChild(cl); });
        var kids = track.children;
        var paused = false, visible = true;
        ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
          track.addEventListener(ev, function () { paused = true; }, { passive: true });
        });
        ['pointerleave', 'touchend', 'focusout'].forEach(function (ev) {
          track.addEventListener(ev, function () { paused = false; }, { passive: true });
        });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.02 }).observe(sec);
        }
        (function tick() {
          if (!paused && visible) {
            track.scrollLeft += 0.5;
            var lw = kids[count] ? (kids[count].offsetLeft - kids[0].offsetLeft) : 0;
            if (lw > 0 && track.scrollLeft >= lw) { track.scrollLeft -= lw; }
          }
          requestAnimationFrame(tick);
        })();
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setH() {
      var ann = document.querySelector('.announcement-bar');
      if (!ann) return;
      var sec = ann.closest('.shopify-section');
      if (!sec) return;
      document.documentElement.style.setProperty('--ag-ann-h', sec.offsetHeight + 'px');
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', setH); } else { setH(); }
    window.addEventListener('resize', setH);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
